import { css } from '@emotion/css';

export const inputAutoWidthStyles = (characters: number) => css`
  width: ${characters}ch;
  min-width: 4ch;
`;

export const blankContainerStyles = css`
  height: 3.8rem;
  display: inherit;
`;

export const questionEditorStyles = css`
  &.heading-m {
    font-size: 2rem;
    font-weight: normal;
  }
`;

export const closeButtonStyles = css`
  height: 2rem;
  width: 2rem;
  svg {
    width: 1.6rem;
    height: 1.6rem;
  }
  background-color: var(--icon-placeholder);
  :hover {
    background-color: var(--icon-secondary);
  }
`;
